import React, { useContext, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CustomInput } from 'reactstrap';
import AppContext from '../../context/Context';
import classNames from 'classnames';

const SidePanel = () => {
    const { isFluid, setIsFluid, isDark, setIsDark, setIsRTL, navbarPosition, setNavbarPosition } = useContext(AppContext);
    const [isOpen, setIsOpen] = useState(false);
    const [navbarStyle, setNavbarStyle] = useState('opaque');

    const toggle = () => setIsOpen(!isOpen);

    const handleReset = () => {
        setIsDark(false);
        setIsFluid(false);
        setNavbarStyle('opaque');
        setIsRTL(false);
        setNavbarPosition('vertical');
    };

    useEffect(() => {
        const navbar = document.querySelector('.navbar-vertical');
        if (navbar) {
            navbar.classList.remove('navbar-vertical-transparent', 'navbar-vertical-card', 'navbar-vertical-black', 'navbar-vertical-blue');
            if (navbarStyle !== 'opaque') {
                navbar.classList.add(`navbar-vertical-${navbarStyle}`);
            }
        }
    }, [navbarStyle, navbarPosition]);

    const themeOptions = [
        { key: 'light', title: 'Kunduzgi', active: !isDark, onClick: () => setIsDark(false), previewClass: 'light' },
        { key: 'dark', title: 'Tungi', active: isDark, onClick: () => setIsDark(true), previewClass: 'dark' }
    ];

    const sidebarOptions = [
        { key: 'transparent', title: 'Shaffof', style: 'transparent', previewClass: 'transparent' },
        { key: 'black', title: 'Qora', style: 'black', previewClass: 'black' },
        { key: 'card', title: 'Karta', style: 'card', previewClass: 'card' },
        { key: 'blue', title: "Ko'k", style: 'blue', previewClass: 'blue' }
    ];

    return (
        <div className="settings-panel">
            <Button
                color="primary"
                className="settings-panel-toggle med-settings-toggle shadow-lg d-flex align-items-center justify-content-center"
                onClick={toggle}
            >
                <FontAwesomeIcon icon="cog" spin={isOpen} className="fs-1" />
            </Button>

            <div className={classNames('settings-panel-backdrop', { show: isOpen })} onClick={toggle} />

            <div className={classNames('settings-panel-wrapper med-settings-panel', { show: isOpen })}>
                <div className="med-settings-header">
                    <div className="d-flex align-items-center">
                        <div className="med-settings-header-icon">
                            <FontAwesomeIcon icon="sliders-h" />
                        </div>
                        <div>
                            <h5 className="mb-0 fs-0 font-weight-bold text-white">Sozlama</h5>
                            <div className="med-settings-header-subtitle">Tizim o'zingiz uchun sozlang</div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <Button color="link" size="sm" className="med-settings-return" onClick={handleReset}>
                            <FontAwesomeIcon icon="reply" className="mr-1" /> Asliga qaytarish
                        </Button>
                        <Button close className="med-settings-close" onClick={toggle} />
                    </div>
                </div>

                <div className="med-settings-body">
                    <div className="med-settings-section">
                        <div className="med-settings-section-title">Ko'rinish ranglari</div>
                        <div className="med-settings-section-copy">Tizim uchun kerakli ranglar bo'limini tanlang.</div>
                        <div className="med-settings-grid med-settings-grid-2">
                            {themeOptions.map(option => (
                                <button
                                    key={option.key}
                                    type="button"
                                    className={classNames('med-preview-card', `med-preview-card-${option.previewClass}`, {
                                        active: option.active
                                    })}
                                    onClick={option.onClick}
                                >
                                    <div className="med-preview-frame">
                                        <span className="med-preview-sidebar" />
                                        <span className="med-preview-header" />
                                        <span className="med-preview-chart" />
                                        <span className="med-preview-block med-preview-block-a" />
                                        <span className="med-preview-block med-preview-block-b" />
                                    </div>
                                    <div className="med-preview-meta">
                                        <span className="med-preview-radio" />
                                        {option.title}
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="med-settings-switch-row">
                        <div>
                            <div className="med-settings-switch-title">To'liq joylashish</div>
                            <div className="med-settings-section-copy mb-0">Joylashish uslubini tanlang</div>
                        </div>
                        <CustomInput
                            type="switch"
                            id="fluid-mode-switch"
                            checked={isFluid}
                            onChange={({ target }) => setIsFluid(target.checked)}
                        />
                    </div>

                    <div className="med-settings-section">
                        <div className="med-settings-section-title">Menyu joylashuvi</div>
                        <div className="med-settings-section-copy">Menyu ko'rinish uslubini tanlang</div>
                        <CustomInput
                            type="select"
                            id="navbar-position-select"
                            className="med-settings-select"
                            value={navbarPosition}
                            onChange={({ target }) => setNavbarPosition(target.value)}
                        >
                            <option value="vertical">Yon tarafga</option>
                            <option value="top">Yuqori menyu</option>
                            <option value="combo">Aralash menyu</option>
                        </CustomInput>
                    </div>

                    {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
                        <div className="med-settings-section animate-fade-in">
                            <div className="med-settings-section-title">Yon menyu uslubi</div>
                            <div className="med-settings-section-copy">Yon menyu ko'rinishini tanlang</div>
                            <div className="med-settings-grid med-settings-grid-2">
                                {sidebarOptions.map(option => (
                                    <button
                                        key={option.key}
                                        type="button"
                                        className={classNames('med-sidebar-preview', `med-sidebar-preview-${option.previewClass}`, {
                                            active: navbarStyle === option.style
                                        })}
                                        onClick={() => setNavbarStyle(option.style)}
                                    >
                                        <div className="med-sidebar-preview-frame">
                                            <span className="med-sidebar-preview-rail" />
                                            <span className="med-sidebar-preview-top" />
                                            <span className="med-sidebar-preview-grid" />
                                        </div>
                                        <div className="med-preview-meta">
                                            <span className="med-preview-radio" />
                                            {option.title}
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="med-settings-promo">
                        <div className="med-settings-promo-illustration">
                            <div className="med-promo-card med-promo-card-left" />
                            <div className="med-promo-card med-promo-card-right" />
                            <div className="med-promo-ring" />
                        </div>
                        <h6 className="font-weight-bold mb-2">Mahsulotimiz yoqdimi?</h6>
                        <p className="fs--2 text-600 mb-4">Yangilash uchun biz bilan bog'laning.</p>
                        <Button color="primary" block className="med-settings-connect">
                            Bog'lanish
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidePanel;
